export class LatLngValueConverter {
  toView(latlng: L.LatLng) {
    return latlng && latlng.lat && latlng.lng ? `${latlng.lat.toFixed(5)}, ${latlng.lng.toFixed(5)}` : latlng;
  }
}